/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, LoadingSection } from '@coursera/cds-core';

import _t from 'i18n!nls/xdp';

const styles = {
  loader: css`
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: var(--cds-color-white-0);
    z-index: 10000;
  `,
};

type Props = {
  label?: string;
};

const LoadingOverlay = ({ label }: Props) => (
  <Grid container css={styles.loader}>
    <LoadingSection label={label || _t('Loading...')} />
  </Grid>
);

export default LoadingOverlay;
